import { api } from '@/api/api';
import { Genre } from '@/types';

export const GenreService = {
  list(): Promise<Genre[]> {
    return api.get('/genre/list');
  }
};
